import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { selectLanguageArea } from '@ninety/platform/state';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { TerraIconModule } from '@ninety/terra';
import { NinetyCMModule } from '@ninety/ui/core';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

/**
 * This is just an example tiered page for to-dos.
 * Mainly to help demonstrate how the 'hasFeatureAccessGuard' route guard  works.
 * This is meant for the team to replace with their own content or completely remove if not needed.
 * */
@Component({
  selector: 'ninety-todos-tiered-page',
  standalone: true,
  imports: [TerraIconModule, NinetyCMModule, LetDirective],
  template: `<ninety-cm-tiered-page *ngrxLet="todoLang$ as language">
    <div headline>Use {{ language.items }} to Get More Done</div>
    <div description>
      Get access to the {{ language.items }} tool to drive accountability and ensure the completion of every commitment.
      Keep your team focused and on track.
    </div>
    <button ninety-cm-button (click)="onExplorePlansClick()">
      <terra-icon icon="lightning" variant="fill" />
      Explore Essentials Plan
    </button>
    <a href="https://help.ninety.io/introduction-to-to-dos" rel="external" target="_blank"
      >Learn more about {{ language.items }}</a
    >
  </ninety-cm-tiered-page>`,
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TodosTieredPageComponent implements OnInit {
  private readonly store = inject(Store);
  protected readonly todoLang$ = this.store.select(selectLanguageArea('todo'));

  ngOnInit(): void {
    this.store.dispatch(FilterBarActions.hide());
  }

  onExplorePlansClick(): void {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
